import type { EpisodeCategory } from '@common/enums';
import type { IServiceStartingPoint } from '@common/interfaces';
import type { ServiceForSelectedServiceTypeBasic } from '@common/interfaces/processStartWizard';
import { UrlBuilder } from '@common/utils/urlBuilder';
import { generateUrlForRoute } from './hooks/useNavigateTo';

export function getStartProcessUrl(params: {
    episodeCategory: EpisodeCategory;
    newProcessCustomIdentifier?: string;
    patientId?: string;
    service: ServiceForSelectedServiceTypeBasic;
    startingPoint?: IServiceStartingPoint;
}) {
    const { episodeCategory, newProcessCustomIdentifier, patientId, service, startingPoint } = params;
    let urlBuilder;

    if (patientId && service.startingPoints && startingPoint) {
        return generateUrlForRoute(
            'patientCarePath',
            {
                activeTab: 'carePath',
                episodeCategory: startingPoint.service.episodeCategory.name,
                patientId,
            },
            {
                startingPointId: startingPoint.id,
            }
        );
    } else if (patientId) {
        urlBuilder = new UrlBuilder('/episode').add('patientId', patientId).add('episodeCategory', episodeCategory);
    } else {
        urlBuilder = new UrlBuilder('/patients/noBsn').add('forwardToEpisode', episodeCategory!);
    }

    urlBuilder.add('serviceId', service.id).add('withProcedure', Boolean(service.isServiceProvider));

    if ('isExternalHolter' in service) {
        urlBuilder.add('isExternalHolter', !!service.isExternalHolter);
    }

    if (newProcessCustomIdentifier) {
        urlBuilder.add('newProcessCustomIdentifier', newProcessCustomIdentifier);
    }

    return urlBuilder.build();
}
